import { heroEquipment } from "../HeroEquipment";

export const jaszczuroludzie = {
  heroes: {
    "Wódz skinków": {
      id: 0,
      startingEquipment: ["Sztylet", "Dmuchawka"],
      cost: 60,
      number: 1,
      equipmentList: heroEquipment["Jaszczuroludzie z Lustrii"].Skink,
      type: "Bohater",
      stats: {
        Początkowa: [6, 4, 5, 3, 2, 2, 6, 1, 7],
        Maksymalna: [6, 6, 6, 4, 3, 3, 8, 4, 8],
      },
      rules: [
        "Dowódca",
        "Łuskowata skóra (6+)",
        "Trudny do zabicia",
        "Wodny",
        "Zasadzka",
        "Zimnokrwisty",
      ],
      exp: 20,
      skills: [0, 1, 2, 4, 5],
    },
    "Kapłan skinków": {
      id: 1,
      startingEquipment: ["Sztylet", "Kostur"],
      cost: 45,
      number: 1,
      equipmentList: heroEquipment["Jaszczuroludzie z Lustrii"].Kapłan,
      type: "Bohater",
      stats: {
        Początkowa: [6, 2, 3, 3, 2, 1, 4, 1, 6],
        Maksymalna: [6, 6, 6, 4, 3, 3, 8, 4, 8],
      },
      rules: [
        "Łuskowata skóra (6+)",
        "Mag (Magia Pradawnych)",
        "Mistrz magii",
        "Trudny do zabicia",
        "Wiedza tajemna (Kolegia Magii)",
        "Wodny",
        "Zasadzka",
        "Zimnokrwisty",
      ],
      exp: 12,
      skills: [2, 4, 5],
    },
    Saurus: {
      id: 2,
      startingEquipment: ["Sztylet", "Włócznia"],
      cost: 50,
      number: 2,
      equipmentList: heroEquipment["Jaszczuroludzie z Lustrii"].Saurus,
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 1, 4, 4, 1, 1, 1, 8],
        Maksymalna: [5, 6, 1, 4, 4, 3, 4, 4, 9],
      },
      rules: [
        "Łuskowata skóra (5+)",
        "Ograniczony",
        "Stygmat Khorna (kolczasty ogon)",
        "Trudny do zabicia",
        "Zasadzka",
        "Zimnokrwisty",
      ],
      exp: 8,
      skills: [0, 3, 5],
    },
    Skink: {
      id: 3,
      startingEquipment: ["Sztylet", "Dmuchawka"],
      cost: 25,
      number: 15,
      equipmentList: heroEquipment["Jaszczuroludzie z Lustrii"].Skink,
      type: "Stronnik",
      stats: {
        Początkowa: [6, 2, 3, 3, 2, 1, 4, 1, 6],
        Maksymalna: [6, 6, 6, 4, 3, 3, 8, 4, 8],
      },
      rules: [
        "Chorążowie & sygnaliści",
        "Drużyna obsługi",
        "Łuskowata skóra (6+)",
        "Trudny do zabicia",
        "Wodny",
        "Zasadzka",
        "Zimnokrwisty",
      ],
    },
    "Skink kameleon": {
      id: 4,
      startingEquipment: ["Sztylet", "Dmuchawka"],
      cost: 40,
      number: 5,
      equipmentList: heroEquipment["Jaszczuroludzie z Lustrii"].Skink,
      type: "Stronnik",
      stats: {
        Początkowa: [6, 2, 4, 3, 2, 1, 4, 1, 6],
        Maksymalna: [6, 6, 6, 4, 3, 3, 8, 4, 8],
      },
      rules: [
        "Kamuflaż",
        "Łuskowata skóra (6+)",
        "Mistrz skrytobójstwa",
        "Nadrzewni drapieżcy",
        "Ranger",
        "Trudny do zabicia",
        "Wodny",
        "Zasadzka",
        "Zwiadowca",
        "Zimnokrwisty",
      ],
    },
    "Jeździec zimnokrwistych": {
      id: 5,
      startingEquipment: [
        "Sztylet",
        "Włócznia",
        "Zimnokrwisty",
        "Siodło & uprząż",
      ],
      cost: 100,
      number: 3,
      equipmentList: heroEquipment["Jaszczuroludzie z Lustrii"].Saurus,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 1, 4, 4, 1, 1, 1, 8],
        Maksymalna: [5, 6, 1, 4, 4, 3, 4, 4, 9],
        Zimnokrwisty: [7, 3, 0, 4, "-", "-", 2, 1, 3],
      },
      rules: [
        "Duży cel (wierzchem)",
        "Kawalerzysta",
        "Łuskowata skóra (5+)",
        "Ograniczony",
        "Stygmat Khorna (kolczasty ogon)",
        "Trudny do zabicia",
        "Zasadzka",
        "Zimnokrwisty",
      ],
    },
    "Jeździec terradonów": {
      id: 6,
      startingEquipment: ["Sztylet", "Oszczep", "Terradon", "Siodło & uprząż"],
      cost: 80,
      number: 3,
      equipmentList: heroEquipment["Jaszczuroludzie z Lustrii"].Skink,
      type: "Stronnik",
      stats: {
        Początkowa: [6, 2, 3, 3, 2, 1, 4, 1, 6],
        Maksymalna: [6, 6, 6, 4, 3, 3, 8, 4, 8],
        Terradon: [2, 3, 0, 4, "-", "-", 2, 1, 3],
      },
      rules: [
        "Kawalerzysta",
        "Lekka jazda",
        "Łuskowata skóra (6+)",
        "Trudny do zabicia",
        "Wodny",
        "Zasadzka",
        "Zimnokrwisty",
      ],
    },
    Kroxigor: {
      id: 7,
      startingEquipment: ["Broń wielka"],
      cost: 180,
      number: 1,
      equipmentList: heroEquipment["Jaszczuroludzie z Lustrii"].Kroxigor,
      type: "Stronnik",
      stats: {
        Początkowa: [6, 3, 1, 4, 4, 3, 1, 2, 7],
        Maksymalna: [6, 6, 5, 5, 5, 5, 6, 5, 9],
      },
      rules: [
        "Bycza szarża",
        "Duży cel",
        "Głód trzewi",
        "Łuskowata skóra (4+)",
        "Ograniczony",
        "Przepastne trzewia",
        "Strach",
        "Stygmat Khorna (kolczasty ogon)",
        "Tempy",
        "Trudny do zabicia",
        "Wielkolud",
        "Wodny",
        "Zasadzka",
        "Zimnokrwisty",
      ],
    },
    Salamandra: {
      id: 8,
      startingEquipment: ["Broń naturalna (zatruty atak)"],
      cost: 180,
      number: 1,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [6, 3, 3, 5, 4, 3, 4, 2, 4],
        Maksymalna: [6, 3, 3, 5, 4, 3, 4, 2, 4],
      },
      rules: [
        "Głód trzewi",
        "Łowcza grupa",
        "Łuskowata skóra (4+)",
        "Potwór",
        "Trudny do zabicia",
        "Wodny",
        "Struga płomieni",
        "Zimnokrwisty",
        "Zwierzę",
      ],
    },
    "Wóz bojowy": {
      id: 9,
      startingEquipment: [],
      cost: 175,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Powóz: ["-", "-", "-", 4, 8, 8, "-", "-", "-"],
        Zimnokrwisty: [7, 3, 0, 4, "-", "-", 2, 1, 3],
        "Zimnokrwisty ": [7, 3, 0, 4, "-", "-", 2, 1, 3],
      },
      rules: [
        "Duży cel",
        "Głupota",
        "Machina wojenna",
        "Powóz",
        "Strach",
        "Wóz bojowy",
      ],
    },
    Rydwan: {
      id: 10,
      startingEquipment: [],
      cost: 150,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Rydwan: ["-", "-", "-", 5, 5, 8, "-", "-", "-"],
        Zimnokrwisty: [7, 3, 0, 4, "-", "-", 2, 1, 3],
        "Zimnokrwisty ": [7, 3, 0, 4, "-", "-", 2, 1, 3],
      },
      rules: ["Duży cel", "Głupota", "Machina wojenna", "Rydwan", "Strach"],
    },
  },
  limit: 500,
  minModels: 3,
  maxModels: 15,
  name: "Jaszczuroludzie z Lustrii",
  nature: "Praworządna",
  armyRules: ["Podatek", "Rozrzutność"],
  mercenaries: [],
};
